import { Form, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { auth } from "../../firebase";
import { getAll } from "../../servicios/sucursales/servicios.ts";
import { LoadingOutlined } from "@ant-design/icons";

const Sucursales = ({ onSucursalChange }) => {
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const loadData = async () => {
      const tokenValid = await auth.currentUser.getIdToken(true);
      getAll(tokenValid)
        .then((data) => {
          // ...
          setData(data.info);
          setLoading(false);
        })
        .catch((err) => {
          setData([]);
        });
        setLoading(false);
    };

    loadData();
  }, []);

  return (
    <Form.Item
      label="Sucursal"
      name="sucursal"
      rules={[
        {
          required: true,
          message: "Por favor selecciona una sucursal",
        },
      ]}
    >
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 24, color: "#08c" }} spin />
          }
        />
      ) : (
        <Select defaultValue={"0"} onChange={onSucursalChange}>
          <Option value="0" disabled>
            Selecciona una sucursal
          </Option>
          {data.map((item) => (
            <Option key={item.name}>{item.name}</Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default Sucursales;
